import { MutatingDots } from "react-loader-spinner";

type LoaderProps = {
  message?: string;
};

const Loader = ({ message = "Processing your request..." }: LoaderProps) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0A1F2933] backdrop-blur-sm">
      <div className="flex flex-col items-center gap-2">
        <MutatingDots
          visible
          height="100"
          width="100"
          color="#127B8D"
          ariaLabel="loading"
        />
        <p className="text-center font-nunito text-lg font-semibold text-[#266985]">
          {message}
        </p>
      </div>
    </div>
  );
};

export default Loader;
